import { render, staticRenderFns } from "./Overviews.vue?vue&type=template&id=10324200&scoped=true"
import script from "./Overviews.vue?vue&type=script&lang=js"
export * from "./Overviews.vue?vue&type=script&lang=js"
import style0 from "./Overviews.vue?vue&type=style&index=0&id=10324200&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10324200",
  null
  
)

export default component.exports